import styles from './Algolia.App.module.scss';
import React, { useRef } from 'react';
import { AlgoliaAppProvider } from './contexts/App.provider';
import { AlgoliaDataProvider } from './contexts/Data.provider';
import { HierarchyProvider } from './contexts/Hierarchy.provider';
import { FiltersSidebar, Header, Toolbar, Items, StatusBar, PaginationBlock, ProgressBar, BackToTopButton, SupplementaryContent } from './components';
import FilterByTags from './components/FilterByTags/FilterByTags';
import { InnerLink } from './components/InnerLink';
import { MEDIA_BREAKPOINTS } from '../constants/MEDIA_BREAKPOINTS';
import { useSearchForm } from './hooks/useSearchForm';
import { SEOCanonicalURL } from './components-renderless/SEO.CanonicalURL';
import { SEOMetaData } from './components-renderless/SEO.MetaData';
import { useAnalytic } from './configs';
import { DLViewHit } from './components-renderless/DL.viewHit';
import { DLCollectionData } from './components-renderless/DL.collectionData';
import { DLCustomPageViewEvent } from './components-renderless/DL.customPageViewEvent';
import { DLSearchEvent } from './components-renderless/DL.searchEvent';
const App = () => {
    const itemsAPIRef = useRef(null);
    useSearchForm();
    return (React.createElement("div", { className: `page-width ${styles.appContainer} ${styles.appWithSidebarContainer}` },
        MEDIA_BREAKPOINTS.XL_UP.matches &&
            React.createElement(FiltersSidebar, null),
        React.createElement("div", null,
            React.createElement(Header, null),
            React.createElement(FilterByTags, null),
            React.createElement(Toolbar, { itemsAPIRef: itemsAPIRef }),
            React.createElement(StatusBar, null),
            React.createElement(Items, { ref: itemsAPIRef }),
            React.createElement(ProgressBar, null),
            React.createElement(PaginationBlock, null),
            React.createElement(SupplementaryContent, null),
            React.createElement(InnerLink, null),
            React.createElement(BackToTopButton, null))));
};
export const AlgoliaApp = ({ pagePath }) => (React.createElement(AlgoliaAppProvider, { pagePath: pagePath },
    React.createElement(HierarchyProvider, null,
        React.createElement(AlgoliaDataProvider, null,
            React.createElement(App, null),
            React.createElement(SEOCanonicalURL, null),
            React.createElement(SEOMetaData, null),
            useAnalytic && React.createElement(DLViewHit, null),
            pagePath !== 'search' && React.createElement(DLCollectionData, null),
            React.createElement(DLCustomPageViewEvent, null),
            pagePath === 'search' && React.createElement(DLSearchEvent, null)))));
